import {TweenLite} from 'gsap';
import 'EasePack';
import loadFonts from '@/scripts/utils/load-fonts';
import '@/scripts/elements/scroll-to-top';
import '@/scripts/elements/cover';
import '@/scripts/elements/preloader';
import '@/scripts/elements/cookies';
import '@/scripts/scrollmagic';
import '@/styles/main.scss';
import initHeaderNav from '@/scripts/elements/header-nav';
import initPopupPage from '@/scripts/elements/page-popup';
import initButtons from '@/scripts/elements/buttons';
import fromInputFocusin from '@/scripts/blocks/form-input';
import initCoverSlider from '@/scripts/blocks/cover-slider';
import initTwoHalvesSlider from '@/scripts/blocks/two-halves-img-slider';
import initIsopotGrids from '@/scripts/elements/isotop-grid';
import initFilters from '@/scripts/blocks/filters';
import initHoverParallax from '@/scripts/elements/hover-parallax';
import googleMaps from '@/scripts/blocks/google-map';

TweenLite.defaultEase = Power1.easeOut;

loadFonts(['PT+Sans:400,700:latin', 'Montserrat:300,400,500,700:latin', 'Cormorant:300,400,500,700']);
document.addEventListener('DOMContentLoaded', () => {
  initHeaderNav({
    menuContainer: '.menu__section_categories',
    menuWrapper: '.header__menu-wrapper',
    transitionDuration: 450, // $_menu-duration in scss file.
  });
  initPopupPage({
    popupContainer: '[data-type="popup-container"]',
    popupButton: '[data-type="popup-button"]',
  });
  initButtons();
  fromInputFocusin();
  initCoverSlider();
  initTwoHalvesSlider();
  initFilters();
  initHoverParallax();
  googleMaps('.map', {apiKey: 'AIzaSyCBO6U8DXwI_SHBgVmZ8tkRIj9msqbKRZs'});
});
window.onload = () => {
  initIsopotGrids();
};



// WEBPACK FOOTER //
// ./scripts/main.js